import { Classes } from "@blueprintjs/core";

import { Box, Flex } from "@/components/layout/flexbox";
import { Container } from "@/components/pieces/bootstrap";
import { InPartnership } from "@/components/pieces/marketing/InPartnership";
import { SignUpForm } from "@/components/pieces/signup/SignUpForm";
import { BRAND_PURPLE } from "@/css/constants";

export function MainHero() {
  return (
    <Box
      css={{
        background:
          "radial-gradient(26.97% 26.97% at 50% 73.03%, #FFFFFF 0%, #F8F7F1 100%)",
      }}
    >
      <Container>
        <Flex
          py={[48, 85]}
          justifyContent="space-between"
          alignItems="center"
          flexWrap="wrap"
        >
          <Box flex={[null, null, 1]} maxWidth={["100%", "100%", "100%", 550]}>
            <InPartnership />
            <h1 style={{ marginTop: 0 }}>
              <Box
                fontSize={[36, 48, 60]}
                fontWeight={700}
                color={BRAND_PURPLE}
                lineHeight="115%"
                fontFamily="poppins"
                css={{ maxWidth: 550 }}
              >
                Achieve your potential with a coach
              </Box>
            </h1>
            <Box fontSize={26}>
              Meet 1:1 with a coach to improve your performance at work,
              accelerate your job search, and earn more money.
            </Box>
          </Box>
          <Box
            flex={[null, null, 1]}
            backgroundColor="#FFF"
            className={`${Classes.ELEVATION_2} round-corners`}
            p={24}
            maxWidth={["100%", "100%", "100%", 500]}
            mt={[24, 24, 24, 0]}
            ml={[0, 0, 4]}
          >
            <Box fontFamily="poppins" fontWeight={600} fontSize={22} mb={3}>
              Redeem Your Gift Code
            </Box>
            <SignUpForm
              fields={["name", "email", "giftCode"]}
              nextPath={"/dashboard"}
            />
          </Box>
        </Flex>
      </Container>
    </Box>
  );
}
